import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-refills',
  templateUrl: './refills.component.html',
  styleUrls: ['./refills.component.css']
})
export class RefillsComponent implements OnInit {
  //dataSource = ELEMENT_DATA;
  displayedColumns = ['id', 'Patient', 'AsssignedTo', 'PracticeProvider', 'Urgency', 'Phone', 'Pharmacy', 'date', 'priority'];
  constructor() { }

  ngOnInit() {
  }

}

